// store/modules/userInfo.js
import { LIST_ROLE_CAN_FILTER_ACCOUNT_FOR_REPORT } from '@/constant/report'
import { getFunctionAssignApi } from '@/api/userConfig/user'

export default {
  namespaced: true,
  state: {
    user: JSON.parse(localStorage.getItem('UserInfo'))?.user || null,
    assignFunctions: []
  },
  getters: {
    isAdmin: (state) => {
      return state.user?.user_group_ids?.some((item) => item.name === 'Admin') || false
    },
    isIT: (state) => {
      return state.user?.user_group_ids?.some((item) => item.name === 'IT-Head') || false
    },
    // Only Use For Report View
    isAdminInReport: (state) => {
      return state.user?.user_group_ids?.some(
        (item) =>
          item.name === 'Admin' ||
          item.name === 'FO-Supervisor' ||
          item.name === 'FO-Head'
      ) || false
    },
    canFilterAccountInReport: (state) => {
      console.log('[Vuex getter] state.user:', state.user)
      return state.user?.user_group_ids?.some((item) =>
        LIST_ROLE_CAN_FILTER_ACCOUNT_FOR_REPORT.includes(item.name)
      ) || false
    },
    isSale: (state) => {
      return state.user?.user_group_ids?.some(
        (item) =>
          item.name === 'Sale-Head' ||
          item.name === 'Sale-Supervisor' ||
          item.name === 'Sale-Staff' ||
          item.name === 'Sale-All'
      ) || false
    },
    isAcc: (state) => {
      return state.user?.user_group_ids?.some(
        (item) =>
          item.name === 'Acc-Head' ||
          item.name === 'Acc-Staff' ||
          item.name === 'Acc-All'
      ) || false
    },
    userInfo: (state) => state.user
  },
  mutations: {
    SET_USER_INFO(state, data) {
      console.log('save user', data)
      state.user = data.user
    },
    REMOVE_USER_INFO(state) {
      state.user = null
    },
    SET_ASSIGN_FUNCTIONS(state, list) {
      state.assignFunctions = list || []
    }
  },
  actions: {
    setUserInfo({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    removeUserInfo({ commit }) {
      commit('REMOVE_USER_INFO')
    },
    async getUserAssignFunctions({ commit }, userId) {
      const res = await getFunctionAssignApi({ accountId: userId })
      commit('SET_ASSIGN_FUNCTIONS', res.data || [])
    }
  }
}
